// Comment.tsx
import React, { useEffect, useState } from "react"
import ApiInterface from "@/commons/api/ApiInterface"
import { decoded } from "@/commons/base64/Decoder"

interface CommentProps {
    commentJson: {
        id: string
        content: string
        time: string
        userId: {
            id: string
            username: string
            staffGroup: {
                groupName: string
                id: number
            }
        }
    }
    onClickUsername?: (userId: string, event: React.MouseEvent<HTMLDivElement>) => void
}

const Comment: React.FC<CommentProps> = ({ commentJson, onClickUsername = () => {} }) => {
    const [imageUrl, setImageUrl] = useState("")
    const [content, setContent] = useState("")

    useEffect(() => {
        async function prepare() {
            const user = commentJson.userId
            const img = await ApiInterface.loadRoleImage(user.staffGroup.id)
            if (!img) return
            setImageUrl(img)
        }
        prepare()

        try {
            setContent(decoded(commentJson.content))
        } catch {
            setContent(commentJson.content)
        }
    }, [commentJson])

    useEffect(() => {
        const load = async () => {
            const raw = decoded(commentJson.content)
            const withImages = await getImage(raw)
            setContent(withImages)
        }
        load();
    }, [commentJson])

    const formatDate = (dateStr: string) => {
        const date = new Date(dateStr)
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
    }

    const getImage = async (text: string) => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(text, "text/html")
        const imgTags = doc.getElementsByTagName("img")

        for (let i = 0; i < imgTags.length; i++) {
            const img = imgTags[i]
            const UUID = img.getAttribute("src")
            if (!UUID) continue
            if (UUID.startsWith("http") || UUID.startsWith("data:image")) continue

            const result = await ApiInterface.getImage(UUID)
            if (result.status === 200) {
                const json = await result.json()
                img.setAttribute("src", json.value)
            } else if (result.status === 404) {
                const result2 = await ApiInterface.getFileUrl(UUID)
                img.setAttribute("src", result2 || UUID)
            } else {
                img.setAttribute("src", UUID)
            }
        }

        return doc.documentElement.innerHTML
    }


    return (
        <div className="post_comment" id={`comment_${commentJson.id}`}>
            <div
                className="post_comment_header clickable"
                onClick={e => onClickUsername(commentJson.userId.id, e)}
                dangerouslySetInnerHTML={{
                    __html: `${commentJson.userId.username} <img src="${imageUrl}" alt="${commentJson.userId.staffGroup.groupName}" />`,
                }}
            />
            <div className="post_comment_body" dangerouslySetInnerHTML={{ __html: content }} />
            <div className="post_comment_date">{formatDate(commentJson.time)}</div>
            <div className="post_comment_separator" />
        </div>
    )
}

export default Comment